import type { RouteRecordRaw } from 'vue-router'
const DefaultLayout = () => import('@/layouts/DefaultLayout.vue')

export const couponsRoutes: RouteRecordRaw[] = [
  {
    path: '/coupons',
    component: DefaultLayout,
    meta: {
      requireAuth: true,
      module: 'couponsTools'
    },
    children: [
      {
        path: '',
        redirect: { name: 'coupons.list' }
      },
      {
        path: '',
        component: () =>
          import('@/views/toolsOperations/toolOperationsHomeView.vue'),
        children: [
          {
            path: 'list',
            name: 'coupons.list',
            component: () =>
                import('@/modules/operationsTools/coupons/ui/view/couponsList.vue'),
            
          },
          {
            path: 'groups',
            name: 'coupons.groups',
            component: () =>
                import('@/modules/operationsTools/coupons/ui/view/groupList.vue'),
            
          },
        ]
      }
    ]
  }
]
